/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect, useSelector } from 'react-redux';

import { createStructuredSelector } from 'reselect';
import _, { isNil } from 'lodash';
import { toast } from 'react-toastify';
import { get, isEmpty } from 'lodash';
import currentUserStorage from 'containers/services/security/current-user-storage';
import {
  Container,
  SahamTabsGlobal,
  StyledTopDiv,
} from 'containers/CourtManagerLegalProceedings/styled-components';
import ClaimRecap from 'containers/LawyerRecapPage/LawyerRecap';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';

import GlobalLegalProceedingTabs from 'components/GlobalLegalProceedingTabs';
import {
  makeSelectCurrentInstanceTab,
  makeSelectCurrentTabManager,
  makeSelectLinkToBeneficiaryCodes,
  makeSelectListings,
  makeSelectGlobalCurrentTabManager,
  makeSelectCurrentTabJudiciaryProcessManager,
  makeSelectNotificationsInboxes,
  makeSelectCurrentTabIndexExpertise,
  makeSelectCurrentRegulationPath,
  makeSelectNotification,
} from 'containers/AppContainer/selectors';
import { makeSelecClaimRecap } from 'containers/RecapManagerPage/selectors';
import {
  requestAssigment,
  requestClaimRecap,
  requestUpdateVictimInfo,
  requestUpdateBeneficiaryInfo,
  requestUpdateVehicleInfo,
  setClaimRecap,
  requestValidateProvisionIntervenant,
  resetStoreClaim,
} from 'containers/RecapManagerPage/actions';
import {
  requestSearchClaims,
  resetSearchClaimsStore,
} from 'containers/IdentificationPage/actions';
import { makeSelectSearchClaims } from 'containers/IdentificationPage/selectors';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { translate } from 'containers/services/translate';
import {
  makeSelectExpertiseRaport,
  makeSelectJudgementAdd,
  makeSelectJudgementOnMerits,
  makeSelectJudgementAppeal,
  makeSelectDahirAmounts,
  makeSelectDahirAmountsCorpo,
  makeSelectJudgementOnMeritsAppeal,
  makeSelectExpertiseRaportAppeal,
  makeSelectJudgementAddAppeal,
  makeSelectJudgementOnMeritsMultiple,
  makeSelectAppealOnMeritsMultiple,
} from 'containers/LawyerLegalProceedingsPage/selectors';
import {
  requestGetJudgementAdd,
  requestGetDahirAmount,
  requestCreateJudgementOnMeritsContestation,
  requestGetJudgementOnMeritsAppeal,
  requestGetExpertiseReportAppeal,
  requestGetJudgementAddAppeal,
  updateContestation,
  requestUploadContestationDocument,
  requestGetJudgementOnMeritsMultiple,
  requestGetAppealOnMeritsMultiple,
  setLockedClaim,
  resetLegalProceeding,
} from 'containers/LawyerLegalProceedingsPage/actions';
import {
  requestMakeJudgementAddDecision,
  requestValidateExpertReport,
  requestValidateJudgementOnMerits,
  requestValidateJudgementAppeal,
  requestCreateCivilProceeding,
  requestAssignedExpert,
  requestValidateDisclaimerWarranty,
  requestUpdatedCivilProceeding,
  requestValidatedCivilProceeding,
  requestMakeJudgementAddDocumentDecision,
  requestAddVictims,
  requestAddVehicles,
  requestMakeDecisionMissionExpertise,
  requestMakeDecisionMissionNoticeDeficiency,
  requestIsSuspiciosClaim,
  requestCreateJudgementAdd,
  requestLockClaim,
  requestUnlockClaim,
  requestMakeDecisionsDocumentImaging,
  requestGetClaimHistoryActions,
  setDecisionsJudgementIds,
  requestGetClaimHistorySagis,
  requestSetStatusClaimSagis,
  requestCreateStakeHolder,
  requestSetPriorityClaimProvision,
  requestGetInstructions,
  requestCreateInstruction,
  requestResetHistoryStore,
  requestCreateIncomeCertificate,
  requestUpdateIncomeCertificate,
  requestMakeDecisionIncomeCertificate,
  requestMakeDecisionSupportDocument,
  requestGetPendingTasksClaim,
  requestGetClaimCivilParty,
  requestArchiveJudgement,
  requestUploadDocumentManager,
  requestGetDecisionFlowVictims,
  requestUpdateInstruction,
  requestUpdateCivilProceeding,
} from 'containers/CourtManagerLegalProceedings/actions';
import {
  IAppealPayload,
  ICurrentSteps,
  IJudgementAdd,
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { getLegalProceedingsSteps } from 'containers/LawyerAssignmentsPage/actions';
import { makeSelectLegalProceedingsSteps } from 'containers/LawyerAssignmentsPage/selectors';
import {
  requestGetExpertiseRaport,
  requestGetJudgementOnMerits,
  requestGetJudgementAppeal,
  requestCreateMultipleJudgementAdd,
  requestGetDahirAmountCorpo,
  requestCreateExpertiseRaport,
  requestAddSupportDocument,
  requestCivilPartySupportDocument,
  requestAddExpertiseSupportDocument,
  requestAddJudgementOnMeritsSupportDocument,
} from 'containers/LawyerLegalProceedingsPage/actions';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';
import {
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
  requestGetReportsPolicy,
} from 'containers/UploadDocuments/actions';
import {
  requestCreateFeeNote,
  requestUpdateFeeNoteStatus,
  requestUpdateFirmReferenceManager,
  requestUpdateInvoiceFeeNote,
} from 'containers/LawyerFeeNote/actions';
import {
  requestCreateFeeNoteManager,
  requestManagerFeeNotes,
} from 'containers/ManagerFeeNote/actions';
import { requestGetDocByDocumentumId } from 'containers/common/UploadDocument/actions';
import { requestFeeNoteExceptionalCosts } from 'containers/ManagerFeeNote/actions';
import { requestCorporealLawyers } from 'containers/RecapManagerPage/actions';
import {
  makeSelectDocument,
  makeSelectDocumentId,
} from 'containers/UploadDocuments/selectors';
import {
  makeSelectCountFeeNotes,
  makeSelectFeeNotes,
  makeSelectAllFeeNotes,
} from 'containers/LawyerFeeNote/selectors';
import { makeSelectCivilProceeding } from 'containers/LawyerLegalProceedingsPage/selectors';
import { requestCreateJudgementOnMerits } from 'containers/LawyerLegalProceedingsPage/actions';
import { PAGES } from 'routes';
import routesHelper from 'containers/services/routes-helper';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { FeeNote } from 'containers/LawyerFeeNote/typings';
import DialogFeeNote from 'components/DialogFeeNote';
import {
  requestFeeNotesByClaimNumb,
  requestAllFeeNotes,
} from 'containers/ManagerFeeNote/actions';
import { makeDecisionFeeNote } from 'containers/ManagerFeeNote/actions';
import { requestGetCivilProceeding } from 'containers/LawyerLegalProceedingsPage/actions';
import {
  requestGetNotificationsInboxes,
  setCurrentIndexTabTransaction,
  setCurrentInstanceTab,
  setNotification,
} from 'containers/AppContainer/actions';
import { CLAIM_STATUS } from 'containers/data-structure';
import DialogCivilProceeding from 'components/DialogCivilProceeding';
import CivilProceedingForm from 'containers/CourtManagerLegalProceedings/civilProceeding';
import { makeSelectCorporealLawyers } from 'containers/RecapManagerPage/selectors';
import ManagerLegalProceedingsPage from 'containers/CourtManagerLegalProceedings/legalProceeding';
import AssignExpertDrawer from 'containers/CourtManagerLegalProceedings/AssignExpert/DrawerExpert';
import DialogDisclaimerWarranty from 'components/DialogDisclaimerWarranty';
import { requestAddInvoiceFeeNote } from 'containers/LawyerFeeNote/actions';
import {
  requestSagisClaimInfo,
  requestGetJudgementOnMeritsByVictims,
  requestGetJudgementOnMeritsByVehicles,
  requestCreateCorpoEncryptedDocument,
  requestCreateCorporealRegulation,
  requestCreateMaterialRegulation,
  requestCreateAdditionalWarrentiesRegulation,
  requestMaterialEncryptedDocument,
  requestGetAssignedLawyers,
  requestGetRegulations,
  resetSagisInfoClaim,
  requestCreateSummarySheetRegulation,
  uploadDocumentRegulation,
  requestValidateProvision,
  requestGetRegulation,
} from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';
import {
  makeSelectSagisClaim,
  makeSelectJudgementOnMeritsByVictims,
  makeSelectJudgementOnMeritsByVehicles,
  makeSelectEncryptedDocuments,
  makeSelectMaterialEncryptedDocuments,
  makeSelectAssignedLawyers,
  makeRegulations,
  makeCreatedRegulations,
} from 'containers/CourtManagerLegalProceedings/Provision/redux/selectors';
import { DamageType } from 'containers/CourtManagerLegalProceedings/typings';
import {
  CLAIM_TYPE_INIT_STATE,
  DAMAGE_INIT_STATE,
  OTHER_DAMAGE_INIT_STATE,
  OTHER_PROPERTIES_DESCRIPTION_SIZE_LIMIT,
  VEHICLE_FORM_INIT_STATE,
  VEHICLE_FORM_VALUES_INIT_STATE,
  VICTIM_FORM_INIT_STATE,
  VICTIM_FORM_VALUES_INIT_STATE,
} from 'containers/CourtManagerLegalProceedings/constants';
import { VehicleForm } from 'containers/CourtManagerLegalProceedings/typings';
import {
  getRiskIdFromPolicyInfo,
  claimTabs,
  filterVehicle,
  filterVictim,
  formatPayloadAddJudiciaryProcess,
  isLockedClaim,
  filterFeeNotes,
  isBlockStatusClaim,
  renderTabsTitle,
  formatSagisVictimsForValidationJudiciaryProcess,
  getLabelsWithLabelsIds,
  getCourtFileNumber,
  getClaimInfoSagis,
  formatSagisVictimsForAddVictim,
  getVictimNamesWithJudgement,
  getVictimNamesWithTransaction,
  extractUpdatedDocument,
  formatOpposingParties,
} from 'containers/CourtManagerLegalProceedings/utils';
import { TopCard } from 'containers/CourtManagerLegalProceedings/TopCard';
import JudiciaryProcessTabs from 'components/JudiciaryProcessTabs';
import { LISTINGS } from 'containers/data-structure';
import useDeepCompareEffect from 'use-deep-compare-effect';
import AssignmentClaimDrawer from 'components/AssignmentClaimDrawer';
import AssignmentDialog from 'containers/RecapManagerPage/AssignmentDialog';
import VictimFormComponent from 'containers/CourtManagerLegalProceedings/VictimFormComponent';
import {
  requestAddTransaction,
  requestGetTransaction,
  requestUpdateTransaction,
  requestAddContactTransaction,
  requestGetContactTransaction,
  resetStoreTransaction,
  requestUpdateContactTransaction,
  requestGetMissionTransaction,
  requestGetMissionVictimExpertise,
  requestUpdateMissionTransaction,
  requestGetFeeNotesTransaction,
} from 'containers/TransactionManagerTimeLine/actions';
import * as util from 'containers/RecapManagerPage/utils';
import { ITEM_KEYS, SAGIS_KEYS } from 'containers/RecapManagerPage/constants';
import ExpertiseExpert from 'containers/CourtManagerLegalProceedings/ExpertiseExpert';
import { requestGetExpertiseVictim } from 'containers/ExpertExpertise/actions';
import {
  resolveSagisClaim,
  shouldShowVictimExcludedWarning,
} from 'helpers/utils';
import { requestGetJudgements } from 'containers/common/LegalProceedings/actions';
import { requestUpdateFeeNoteAmount } from 'containers/LawyerFeeNote/actions';
import { victimValidator } from 'containers/RecapManagerPage/VictimDrawer';
import { formsAreValidated } from 'containers/services/validateForm';
import { getAssignedManagerCode } from 'containers/CourtManagerAssignedClaims/utils';
import { makeSelectVictimExpertise } from 'containers/ExpertExpertise/selectors';
import { selectedLoader } from 'containers/AppContainer/Loader/selectors';
import SuspiciosClaimDialog from 'containers/CourtManagerLegalProceedings/SuspiciosClaimDialog';
import SuspiciousCard from 'containers/CourtManagerLegalProceedings/SuspiciousCard';
import { AssignedLawyer } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/typings';
import {
  requestUpdateClaim,
  requestUpdateFraudInfo,
} from 'containers/PreOpeningPage/actions';
import { extractOpposingParties } from 'containers/PreOpeningPage/utils';
import ImagineDocumentsDrawer from 'containers/CourtManagerLegalProceedings/ImagineDocuments';
import useCollapse from 'hooks/useCollapse';
import {
  makeSelectClaimHistoryActions,
  makeSelectDecisionJudgmentIds,
  makeSelectClaimHistorySagis,
  makeInstructions,
  makeSelectPendingTasksClaim,
  makeSelectClaimCivilParty,
  makeSelectDecisionFlowVictim,
} from 'containers/CourtManagerLegalProceedings/selectors';
import TrackingActionDrawer from 'containers/CourtManagerLegalProceedings/TrackingActionDrawer';
import { priorityClaimReason } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import InstructionDrawer from 'containers/CourtManagerLegalProceedings/InstructionDrawer';
import Transaction from 'containers/TransactionManagerTimeLine/Transaction';
import WarningCard from 'containers/common/Card/WarningCard';
import { PROFESSION_CODES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import {
  addPriorityReasonProfession,
  removeDeletedItems,
} from 'services/utils';
import {
  disabledDialogAddVictim,
  disabledPrimaryButton,
} from 'containers/CourtManagerLegalProceedings/utils';
import ProvisionRegulationContainer from 'containers/CourtManagerLegalProceedings/Provision/ProvisionRegulationContainer';
import {
  getCurrentTabJudiciaryProcess,
  getLastGetInstruction,
} from 'containers/LawyerLegalProceedingsPage/utils';
import { GLOBAL_STATUS, OPENING_STATE } from 'services/constants';
import { VictimType } from 'typings/globalTypes';
import { ClaimRecapType } from 'typings/claimTypes';
import { Claim } from 'containers/PreOpeningPage/typings';
import { getAssignedJurisdictionLawyerCode } from 'containers/RecapManagerPage/utils';
import { formatCourtFileNumber } from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import { ALL_STATUS } from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/constants';

export interface CourtManagerLegalProceedingsPageProps {
  intl: IntlShape;
  listings: Listings;
  storedClaimToPreopen: any;
  requestClaimRecap: Function;
  getLegalProceedingsSteps: Function;
  claimRecap: ClaimRecapType;
  currentSteps: ICurrentSteps[];
  policyInfo: { sagis: { claims: any } };
  requestSearchClaims: Function;
  resetSearchClaimsStore: Function;
  match: { params: { claimId: number } };
  requestGetJudgementAdd: Function;
  judgementAdd: IJudgementAdd;
  requestMakeJudgementAddDecision: Function;
  requestGetExpertiseRaport: Function;
  expertiseReport: ExpertReportType;
  requestValidateExpertReport: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  requestValidateJudgementOnMerits: Function;
  requestValidateDisclaimerWarranty: Function;
  requestGetJudgementOnMerits: Function;
  judgementOnMerits: JudgementOnMeritsType;
  documentId: string;
  setDocumentId: Function;
  judgementAppeal: IAppealPayload;
  requestGetJudgementAppeal: Function;
  requestValidateJudgementAppeal: Function;
  requestGetDahirAmount: Function;
  dahirAmount: [];
  feeNotes: FeeNote[];
  feeNotesCount: number;
  resetUploadDocumentStore: Function;
  requestManagerFeeNotes: Function;
  requestFeeNotesByClaimNumb: Function;
  requestCreateFeeNote: Function;
  requestFeeNoteExceptionalCosts: Function;
  keyclokToken: string | null;
  makeDecisionFeeNote: Function;
  currentTabInstance: string;
  setCurrentInstanceTab: Function;
  requestAllFeeNotes: Function;
  allFeeNote: FeeNote[];
  requestCorporealLawyers: Function;
  corporealLawyers: any;
  requestCreateCivilProceeding: Function;
  requestGetCivilProceeding: Function;
  judiciaryProcessId: number;
  civilProceeding: [];
  requestCreateJudgementOnMerits: Function;
  requestAssignedExpert: Function;
  requestUpdatedCivilProceeding: Function;
  selectedClaim: any;
  requestSagisClaimInfo: Function;
  sagisClaim: any;
  dahirAmountsCorpo: any;
  requestGetDahirAmountCorpo: Function;
  requestCreateJudgementOnMeritsContestation: any;
  requestGetJudgementOnMeritsAppeal: any;
  judgementOnMeritsAppeal: any;
  expertiseRaportAppeal: any;
  requestGetExpertiseReportAppeal: any;
  requestGetJudgementAddAppeal: Function;
  requestValidatedCivilProceeding: Function;
  judgementAddAppeal: any;
  requestMakeJudgementAddDocumentDecision: Function;
  requestAssigment: Function;
  requestAddVictims: Function;
  linkToBeneficiaryCodes: SagisConfig[];
  updateContestation: Function;
  requestUploadContestationDocument: Function;
  requestUpdateVictimInfo: Function;
  requestUpdateBeneficiaryInfo: Function;
  requestUpdateVehicleInfo: Function;
  setClaimRecap: Function;
  requestAddVehicles: Function;
  requestGetJudgementOnMeritsMultiple: Function;
  requestGetAppealOnMeritsMultiple: Function;
  judgementOnMeritsMultiple: any;
  appealOnMeritsMultiple: any;
  requestGetJudgementOnMeritsByVictims: Function;
  judgementOnMeritsByVictims: any;
  requestGetJudgementOnMeritsByVehicles: Function;
  judgementOnMeritsByVehicles: any;
  requestGetExpertiseVictim: Function;
  requestMakeDecisionMissionExpertise: Function;
  requestMakeDecisionMissionNoticeDeficiency: Function;
  requestCreateCorpoEncryptedDocument: Function;
  requestCreateCorporealRegulation: Function;
  requestCreateMaterialRegulation: Function;
  requestCreateAdditionalWarrentiesRegulation: Function;
  corporealEncryptedDocuments: any;
  requestUpdateFeeNoteAmount: Function;
  expertExpertise: any;
  materialEncryptedDocuments: any;
  requestMaterialEncryptedDocument: Function;
  loaders: any;
  requestIsSuspiciosClaim: Function;
  requestCreateJudgementAdd: Function;
  requestGetAssignedLawyers: Function;
  assignedLawyers: AssignedLawyer[];
  requestCreateMultipleJudgementAdd: Function;
  requestCreateExpertiseRaport: Function;
  requestUpdateClaim?: Function;
  currentIndexTabManager: any;
  currentGlobalTabManagerIndex: any;
  currentInstanceTabIndexManager: any;
  currentJudiciaryProccessId: any;
  requestAddSupportDocument: Function;
  requestCivilPartySupportDocument: Function;
  requestAddExpertiseSupportDocument: Function;
  requestAddJudgementOnMeritsSupportDocument: Function;
  requestValidateProvisionIntervenant: Function;
  requestLockClaim: Function;
  requestUnlockClaim: Function;
  setLockedClaim: any;
  requestGetRegulations: Function;
  regulations: any;
  managerNotifcationsInboxes: any;
  resetStoreClaim: Function;
  resetSagisInfoClaim: Function;
  resetLegalProceeding: Function;
  createdRegulations: any;
  requestCreateSummarySheetRegulation: Function;
  uploadDocumentRegulation: Function;
  requestMakeDecisionsDocumentImaging: Function;
  requestGetNotificationsInboxes: Function;
  requestValidateProvision: Function;
  currentTabManagerExpertise: any;
  requestAddInvoiceFeeNote: Function;
  requestUpdateInvoiceFeeNote: Function;
  decisionJudgementIds: any;
  requestGetClaimHistoryActions: Function;
  userActions: any;
  requestUpdateFeeNoteStatus: Function;
  setDecisionsJudgementIds: Function;
  requestGetClaimHistorySagis: Function;
  claimHistorySagis: any;
  requestSetStatusClaimSagis: Function;
  requestCreateStakeHolder: Function;
  requestSetPriorityClaimProvision: Function;
  requestGetInstructions: Function;
  requestCreateInstruction: Function;
  instructions: any;
  requestResetHistoryStore: Function;
  requestCreateFeeNoteManager: Function;
  requestCreateIncomeCertificate: Function;
  requestUpdateIncomeCertificate: Function;
  requestGetFeeNotesTransaction: Function;
  requestGetTransaction: Function;
  requestAddTransaction: Function;
  resetStoreTransaction: Function;
  requestUpdateTransaction: Function;
  requestAddContactTransaction: Function;
  requestGetContactTransaction: Function;
  requestGetMissionTransaction: Function;
  requestGetMissionVictimExpertise: Function;
  requestUpdateContactTransaction: Function;
  requestUpdateMissionTransaction: Function;
  requestGetReportsPolicy: Function;
  requestMakeDecisionIncomeCertificate: Function;
  requestMakeDecisionSupportDocument: Function;
  requestGetPendingTasksClaim: Function;
  pendingTasksClaim: any;
  requestGetClaimCivilParty: Function;
  claimCivilParty: any;
  currentRegulationPath: any;
  imagineNotification: any;
  setCurrentIndexTabTransaction: Function;
  setNotification: Function;
  requestArchiveJudgement: Function;
  requestUploadDocumentManager: Function;
  requestGetDocByDocumentumId: Function;
  requestGetJudgements: Function;
  requestUpdateFirmReferenceManager: Function;
  requestGetRegulation: Function;
  requestUpdateFraudInfo: Function;
  requestGetDecisionFlowVictims: Function;
  victimDecisionFlow: any;
  requestUpdateInstruction: Function;
  requestUpdateCivilProceeding: Function;
}

export const CourtManagerLegalProceedingsPage: React.FC<CourtManagerLegalProceedingsPageProps> = (
  props,
): JSX.Element => {
  const [isButtonRedirect, setIsButtonRedirect] = useState(false);
  const [isDecisionFeeNote, setIsDecisionFeeNote] = useState(false);
  const [openTrackingDrawer, setOpenTrackingDrawer] = useState(false);
  const [instruction, setInstruction] = useState('');
  const [updateCivilProcedure, setUpdateCivilProcedure] = useState(false);

  const priorityReasonClaimId = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'priorityReasonId']),
  );

  useEffect(() => {
    if (featureService.hasFeature(FEATURES.AUTOMATIC_LOCK_CLAIM)) {
      return () => {
        props.requestUnlockClaim(
          {
            claimNumber: get(props.claimRecap, 'claim.claimNumber'),
          },
          () => {
            props.setLockedClaim(null);
            props.resetSearchClaimsStore();
            props.resetStoreClaim();
            props.requestResetHistoryStore();
            props.setNotification({});
          },
        );
      };
    } else {
      return () => {
        props.resetSearchClaimsStore();
        props.resetStoreClaim();
        props.requestResetHistoryStore();
        props.setNotification({});
      };
    }
  }, []);

  useEffect(() => {
    if (featureService.hasFeature(FEATURES.AUTOMATIC_LOCK_CLAIM)) {
      const handleBeforeUnload = (event: any) => {
        const message = 'vous allez quitter le mode de gestion du sins';
        event.returnValue = message;
        props.requestUnlockClaim({
          claimNumber: get(props.claimRecap, 'claim.claimNumber'),
        });
      };

      window.addEventListener('beforeunload', handleBeforeUnload);

      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
        props.resetSearchClaimsStore();
        props.resetStoreClaim();
        props.resetSagisInfoClaim();
        props.resetLegalProceeding();
        props.requestResetHistoryStore();
        props.setNotification({});
      };
    } else {
      return () => {
        props.resetSearchClaimsStore();
        props.resetStoreClaim();
        props.resetSagisInfoClaim();
        props.resetLegalProceeding();
        props.requestResetHistoryStore();
        props.setNotification({});
      };
    }
  }, []);

  useDeepCompareEffect(() => {
    if (!isEmpty(get(props.policyInfo, 'sagis', {}))) {
      if (
        !isLockedClaim(props.policyInfo) &&
        featureService.hasFeature(FEATURES.AUTOMATIC_LOCK_CLAIM) &&
        !isNil(get(props.claimRecap, 'claim.claimNumber', null)) &&
        !isBlockStatusClaim(props.policyInfo) &&
        get(props, 'claimRecap.claim.status') === GLOBAL_STATUS.VALIDATED
      ) {
        props.requestLockClaim({
          claimNumber: get(props.claimRecap, 'claim.claimNumber'),
        });
        props.setLockedClaim(get(props.claimRecap, 'claim.claimNumber'));
      }
    }
  }, [props.claimRecap, props.policyInfo]);
  useEffect(() => {
    if (
      !isEmpty(get(props.policyInfo, 'sagis', [])) &&
      featureService.hasFeature(FEATURES.PRIORITY_CLAIM) &&
      (isNil(get(props.claimRecap, 'claim.priorityReasonId', null)) ||
        get(props.claimRecap, 'claim.priorityReasonId', null) != 4)
    ) {
      const priorityReason = priorityClaimReason(
        [],
        !isEmpty(get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []))
          ? get(resolveSagisClaim(props.policyInfo), 'offeredRisks', [])
              .map((el: any) => Number(el.riskProvisions))
              .reduce(
                (accumulator: any, currentValue: any) =>
                  accumulator + currentValue,
              )
          : 0,
        props.listings,
      );
      if (priorityReason) {
        props.requestSetPriorityClaimProvision({
          id: Number(claimId),
          claimInfo: { priorityReasonId: priorityReason },
          username: currentUserStorage.get().username,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
        });
      }
    }
  }, [props.policyInfo]);

  useEffect(() => {
    const assignedManagerCode = get(
      removeDeletedItems(get(props.claimRecap, 'claim.assignment', [])),
      '[0].assignedManagerCode',
      null,
    );
    if (
      !featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER) &&
      assignedManagerCode !==
        getAssignedManagerCode(
          get(props.listings, LISTINGS.ASSIGNMENT_MANAGER, []),
          get(currentUserStorage.get(), 'username', ''),
        ) &&
      !isEmpty(props.claimRecap) &&
      !isEmpty(props.listings) &&
      !userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER)
    ) {
      props.resetSearchClaimsStore();
      props.resetStoreClaim();
      props.resetSagisInfoClaim();
      props.resetLegalProceeding();
      props.requestResetHistoryStore();
      routesHelper.pushTo(PAGES.COURT_MANAGER_HOME)();
    }
    if (
      !isEmpty(props.claimRecap) &&
      get(props, 'claimRecap.claim.status') !== GLOBAL_STATUS.VALIDATED
    ) {
      props.resetSearchClaimsStore();
      props.resetStoreClaim();
      props.resetSagisInfoClaim();
      props.resetLegalProceeding();
      props.requestResetHistoryStore();
      props.setNotification({});
    }
  }, [
    props.claimRecap,
    props.listings,
    props.currentIndexTabManager,
    props.currentInstanceTabIndexManager,
    props.currentTabInstance,
    props.currentRegulationPath,
  ]);
  const [OpenDrawerImagineDocuments, setOpenDraweImagineDocuments] = useState(
    !isEmpty(props.imagineNotification) ? true : false,
  );
  const [expandRow, setExpandRow] = useCollapse(
    get(props.listings, 'managerInboxes', []),
  );

  const handleToggleDrawer = () => {
    setOpenDraweImagineDocuments(!isDrawerOpen);
  };

  const handleToggleTrackingDrawer = () => {
    setOpenTrackingDrawer(!openTrackingDrawer);
  };
  const [stakeholders, setStakeholders] = React.useState([] as SagisConfig[]);
  const [isDrawerOpen, setDrawerOpen] = React.useState(false);
  const [isSuspiciosClaimDialog, setIsSuspiciosClaimDialog] = React.useState(
    false,
  );

  const [procedureType, setProcedureType] = React.useState<null | number>(null);
  const [civilProceedingInfo, setCivilProceedingInfo] = React.useState<
    null | any
  >({});
  const [page, setPage] = React.useState<number>(0);
  const [victimsInfo, setVictimsInfo] = React.useState<null | any>([]);
  const claimId = props.match.params.claimId;
  const claimNumber = get(props.claimRecap, 'claim.claimNumber', null);
  const [civilProceedingDoc, setCivilProceedingDoc] = React.useState<
    null | any
  >([]);
  const [dropDown, setDropDown] = React.useState<null | HTMLElement>(null);
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false);
  const [isExpertFeeNote, setIsExpertFeeNote] = React.useState<boolean>(false);
  const [
    isDialogOpenCivilProceeding,
    setIsDialogOpenCivilProceeding,
  ] = React.useState<boolean>(false);

  useEffect(() => {
    if (isDialogOpenCivilProceeding === false) {
      cleanCivilProceedingStates();
    }
  }, [isDialogOpenCivilProceeding]);
  const [idCivilProceeding, setIdCivilProceeding] = React.useState<number>(0);
  const [isWarrantyDialogOpen, setIsWarrantyDialogOpen] = useState<boolean>(
    false,
  );
  const [currentJudiciaryProcess, setCurrentJudiciaryProcess] = React.useState<
    any
  >({});
  const [isAssignmentDialogOpen, setIsAssignmentDialogOpen] = React.useState<
    boolean
  >(false);
  const [judiciaryProcessType, setJudiciaryProcessType] = React.useState<
    string
  >('');

  const handleCloseAssignmentDialog = () => {
    setIsAssignmentDialogOpen(false);
  };
  const [
    isAssignmentClaimDrawerOpen,
    setIsAssignmentClaimDrawerOpen,
  ] = useState<boolean>(false);
  const [isInstructionDrawerOpen, setIsInstructionDrawerOpen] = useState<
    boolean
  >(false);
  const [isAddVictimCardOpen, setIsAddVictimCardOpen] = useState<boolean>(
    false,
  );
  useEffect(() => {
    const claimId = get(props, ['match', 'params', 'claimId']);
    props.requestGetCivilProceeding(claimId);
  }, [
    claimId,
    props.claimRecap,
    props.currentIndexTabManager,
    props.currentGlobalTabManagerIndex,
  ]);

  useEffect(() => {
    const claimId = get(props, ['match', 'params', 'claimId']);
    if (
      featureService.hasFeature(FEATURES.TRAITEMENT_IMAGINE_DOC) &&
      !isNil(claimNumber)
    ) {
      props.requestGetPendingTasksClaim({
        claimNumber: claimNumber,
      });
    }
    if (featureService.hasFeature(FEATURES.TRANSACTION)) {
      props.requestGetDecisionFlowVictims(claimId);
    }
    if (props.currentJudiciaryProccessId) {
      props.requestGetCivilProceeding(claimId);
      props.requestClaimRecap(claimId);
      setIdCivilProceeding(props.currentJudiciaryProccessId);
      if (get(props.civilProceeding, '[0].id')) {
        props.getLegalProceedingsSteps(
          claimId,
          props.currentJudiciaryProccessId,
        );
        props.requestClaimRecap(claimId);
      }
    } else {
      const correctionnelProceeding = props.civilProceeding.filter(
        (element: { procedureNatureId: number }) =>
          element.procedureNatureId === 3,
      );
      props.requestGetCivilProceeding(claimId);
      props.requestClaimRecap(claimId);
      setIdCivilProceeding(get(correctionnelProceeding, '[0].id'));
      if (get(props.civilProceeding, '[0].id')) {
        props.getLegalProceedingsSteps(
          claimId,
          get(props.civilProceeding, '[0].id'),
        );
        props.requestClaimRecap(claimId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    claimId,
    claimNumber,
    props.currentIndexTabManager,
    props.currentGlobalTabManagerIndex,
    props.currentJudiciaryProccessId,
  ]);

  useEffect(() => {
    if (
      !isEmpty(get(props.policyInfo, 'sagis', {})) &&
      !isEmpty(props.claimRecap)
    ) {
      if (isLockedClaim(props.policyInfo)) {
        toast.error(
          translate({ ...messages.errorLockedClaim }, props, {
            username: get(
              resolveSagisClaim(props.policyInfo),
              'lockedBy',
              null,
            ),
          }) as string,
        );
        props.resetStoreClaim();
        props.resetSearchClaimsStore();
        props.requestResetHistoryStore();
        props.setNotification({});
        routesHelper.pushTo(
          `${PAGES.CONSULTATION_LEGAL_PROCEEDING_PAGE}/${get(props, [
            'match',
            'params',
            'claimId',
          ])}`,
        )();
      } else if (
        isBlockStatusClaim(props.policyInfo) ||
        get(props, 'claimRecap.claim.status') != GLOBAL_STATUS.VALIDATED ||
        get(props, 'claimRecap.claim.openingState') != OPENING_STATE.COMPLETED
      ) {
        props.resetStoreClaim();
        props.resetSearchClaimsStore();
        props.setNotification({});
        routesHelper.pushTo(
          `${PAGES.CONSULTATION_LEGAL_PROCEEDING_PAGE}/${get(props, [
            'match',
            'params',
            'claimId',
          ])}`,
        )();
      }
    }
  }, [
    props.policyInfo,
    props.currentIndexTabManager,
    props.currentInstanceTabIndexManager,
    props.currentGlobalTabManagerIndex,
    props.currentJudiciaryProccessId,
    props.claimRecap,
  ]);
  React.useEffect(() => {
    const _stackholders = util.getListBySagisKey(
      get(props.listings, LISTINGS.STACKHOLDER_TYPE, []),
      get(props.listings, LISTINGS.STACKHOLDERS, []),
      ITEM_KEYS.LAWYER,
      SAGIS_KEYS.ITEM_TYPE as keyof SagisConfig,
    );

    const lawyers = util.getBawabaLawyers(
      _stackholders,
      props.corporealLawyers,
    );
    setStakeholders(lawyers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.listings,
    props.currentIndexTabManager,
    props.currentInstanceTabIndexManager,
    props.currentGlobalTabManagerIndex,
    props.currentJudiciaryProccessId,
  ]);

  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };
  useEffect(() => {
    props.requestCorporealLawyers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!_.isEmpty(props.corporealLawyers)]);
  useEffect(() => {
    if (claimId && !isNil(get(props.claimRecap, 'claim.claimNumber', null))) {
      props.requestGetExpertiseVictim({
        missionId: null,
        claimId,
        missionVictimId: null,
        missionVehicleId: null,
        isIntervenant: false,
        isLegalProceeding: true,
      });
    }
  }, [!claimId, props.claimRecap, idCivilProceeding]);

  const handleOpen = () => {
    props.setDecisionsJudgementIds({});
    setIsExpertFeeNote(false);
    setIsDialogOpen(true);
  };

  const handleOpenAssignment = () => {
    setIsAssignmentClaimDrawerOpen(true);
  };

  const successCallBackReadInstruction = () => {
    props.requestGetInstructions({
      judiciaryProcessId: idCivilProceeding,
    });
  };
  const handleOpenInstructions = () => {
    setIsInstructionDrawerOpen(true);
    if (
      get(getLastGetInstruction(props.instructions), 'createdBy') !=
      get(currentUserStorage.get()?.privileges, 'sagisName')
    ) {
      !isEmpty(props.instructions) &&
        props.requestUpdateInstruction(
          {
            readBy: currentUserStorage.get()?.username,
            judiciaryProcessId: idCivilProceeding,
          },
          successCallBackReadInstruction,
        );
    }
  };

  const handleOpenCivilProceeding = (type: number) => () => {
    setIsDialogOpenCivilProceeding(true);
    setDropDown(null);
    setProcedureType(type);
  };

  const handleOpenDisclaimerWarrantyReasons = () =>
    setIsWarrantyDialogOpen(true);

  const handleOpenExpertiseFeeNote = () => {
    setIsExpertFeeNote(true);
    setIsDialogOpen(true);
  };

  const toggleDrawerAssignmentClaim = () => {
    setIsAssignmentClaimDrawerOpen(!isAssignmentClaimDrawerOpen);
  };

  const toggleDrawerInstruction = () => {
    setInstruction('');
    setIsInstructionDrawerOpen(!isInstructionDrawerOpen);
  };

  const toggleAddVictimCard = () => {
    setIsAddVictimCardOpen(!isAddVictimCardOpen);
  };

  const handleCloseWarrantyDialog = () => setIsWarrantyDialogOpen(false);

  const successCallBackValidationWarrantyReason = () => {
    toast.success(translate(messages.successDialogWarrantyReason, props));
    setIsWarrantyDialogOpen(false);
  };

  const handleValidateWarrantyDialog = (reasonId: number) => () => {
    props.requestValidateDisclaimerWarranty(
      { id: claimId, reasonId },
      successCallBackValidationWarrantyReason,
    );
  };

  const handleResetStore = () => {
    props.requestUnlockClaim(
      {
        claimNumber: get(props.claimRecap, 'claim.claimNumber'),
      },
      () => {
        props.setLockedClaim(null);
        props.resetSearchClaimsStore();
        props.resetStoreClaim();
        props.requestResetHistoryStore();
        props.setNotification({});
      },
    );
  };

  const handleClose = () => {
    setIsDialogOpen(false);
    props.setDecisionsJudgementIds({});
    setIsDecisionFeeNote(false);
  };

  const handleCloseCivilProceeding = () => {
    cleanCivilProceedingStates();
  };

  const cleanCivilProceedingStates = () => {
    setIsDialogOpenCivilProceeding(false);
    setUpdateCivilProcedure(false);
    setOtherDamage(OTHER_DAMAGE_INIT_STATE);
    setDamage(DAMAGE_INIT_STATE);
    setClaimType(CLAIM_TYPE_INIT_STATE);
    setVehicleFormValues(VEHICLE_FORM_VALUES_INIT_STATE);
    setVictimFormValues(VICTIM_FORM_VALUES_INIT_STATE);
    setCivilProceedingDoc([]);
    setCivilProceedingInfo({});
  };

  const successCallBack = () => {
    toast.success(translate(messages.successDialogCivilProceeding, props));
    cleanCivilProceedingStates();
  };

  const successCallBackAddVictims = () => {
    toast.success(translate(messages.successDialogAddVictims, props));
    toggleAddVictimCard();
    setVictimAddFormValues({
      [_.uniqueId()]: { ...VICTIM_FORM_INIT_STATE, beneficiaries: [] },
    } as any);
  };

  const riskKey = getClaimInfoSagis(props.policyInfo)?.riskKey;

  const { labes, labesWithIds } = getLabelsWithLabelsIds(props.civilProceeding);

  const handleValidateProceedingCivil = () => {
    const claimResponsabilityRate = getClaimInfoSagis(props.policyInfo)
      ?.responsibilityRate;
    let isFormValid = true;
    [...Object.values(victimFormValues)].forEach((el: any) => {
      const validator = victimValidator(el);
      setVictimValidation(validator);
      if (!formsAreValidated(validator ? validator : {})) {
        isFormValid = false;
      }
    });
    if (isFormValid) {
      const formattedVictims = formatSagisVictimsForValidationJudiciaryProcess(
        victimFormValues,
        claimResponsabilityRate,
        props.listings,
      );
      const formatedPayload = formatPayloadAddJudiciaryProcess(
        claimId,
        riskKey,
        civilProceedingInfo,
        claimNumber,
        procedureType as any,
        civilProceedingDoc,
        claimType,
        formattedVictims,
        associatedVictims,
        damage,
        riskId,
        victimFormValues,
        props.listings,
        otherDamage,
        associatedOpposingParties,
        vehicleFormValues,
        get(props.claimRecap, 'claim.lossDate'),
        priorityReasonClaimId,
      );
      props.requestCreateCivilProceeding(formatedPayload, successCallBack);
    }
  };

  const [damage, setDamage] = useState<DamageType>(DAMAGE_INIT_STATE);

  const [claimType, setClaimType] = useState({
    corporeal: false,
    material: false,
  });

  const [otherDamage, setOtherDamage] = useState(OTHER_DAMAGE_INIT_STATE);

  const [isReassignmentManager, setIsReassignmentManager] = useState(true);

  const [vehicleFormValues, setVehicleFormValues] = useState<{
    [key: string]: VehicleForm;
  }>({});

  const addVehicleForm = () => {
    setVehicleFormValues(prevVehicleFormValues => {
      return {
        ...prevVehicleFormValues,
        [_.uniqueId()]: VEHICLE_FORM_INIT_STATE,
      };
    });
  };
  const handleOpenUpdateFormCivilProceeding = (payload: any) => {
    setUpdateCivilProcedure(true);
    setIsDialogOpenCivilProceeding(true);
    setCivilProceedingInfo({
      ...payload,
      dateReceiptRequest: payload.receptionDate,
    } as any);
    setAssociatedVictims(payload.victims.map((item: any) => item.id));
    setClaimType({
      corporeal: !isEmpty(payload.victims),
      material: !isEmpty(payload.vehicules) || !isEmpty(payload.otherDamage),
    });
    setAssociatedOpposingParties(payload.vehicules.map((item: any) => item.id));
    setDamage({
      adverseVehicles: !isEmpty(payload.vehicules),
      otherProperties: !isEmpty(payload.otherDamage),
    });
    setCivilProceedingDoc(get(payload, 'documents'));
    setOtherDamage(get(payload, 'otherDamage.[0]', OTHER_DAMAGE_INIT_STATE));
  };

  const [victimFormValues, setVictimFormValues] = useState<{
    [key: string]: VictimType;
  }>({});

  const [associatedVictims, setAssociatedVictims] = useState<any[]>([]);
  const [associatedOpposingParties, setAssociatedOpposingParties] = useState<
    any[]
  >([]);

  const addVictimForm = () => {
    setVictimFormValues(prevVictimFormValues => {
      return ({
        ...prevVictimFormValues,
        [_.uniqueId()]: VICTIM_FORM_INIT_STATE,
      } as unknown) as any;
    });
  };

  const handleChangeOtherDamage = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOtherDamage({
      description: e.target.value.substring(
        0,
        OTHER_PROPERTIES_DESCRIPTION_SIZE_LIMIT,
      ),
    });
  };

  useEffect(() => {
    if (idCivilProceeding != 0) {
      props.civilProceeding.forEach(
        (el: {
          procedureNatureId: number;
          id: number;
          courtNumber: string;
        }) => {
          if (el.id === idCivilProceeding) {
            setIdCivilProceeding(el.id);
            setCurrentJudiciaryProcess(el);
          }
        },
      );
    }
  }, [props.civilProceeding, props.currentJudiciaryProccessId]);

  const handleClickVerticalTabs = (tabIndex: number) => {
    const idCivilProceeding = labesWithIds[tabIndex]?.id;
    props.civilProceeding.forEach(
      (el: { procedureNatureId: number; id: number; courtNumber: string }) => {
        if (el.id === idCivilProceeding) {
          setIdCivilProceeding(el.id);
          setCurrentJudiciaryProcess(el);
        }
      },
    );
  };

  const riskId = getRiskIdFromPolicyInfo(props?.policyInfo);

  const [victimAddFormValues, setVictimAddFormValues] = useState<{
    [key: string]: VictimType;
  }>(({ [_.uniqueId()]: VICTIM_FORM_INIT_STATE } as unknown) as any);
  const [victimValidation, setVictimValidation] = useState({});

  const addVictimCardForm = () => {
    setVictimAddFormValues(prevVictimFormValues => {
      return ({
        ...prevVictimFormValues,
        [_.uniqueId()]: VICTIM_FORM_INIT_STATE,
      } as unknown) as any;
    });
  };

  const validateVictimCardForm = () => {
    const claimResponsabilityRate = getClaimInfoSagis(props.policyInfo)
      ?.responsibilityRate;

    let isFormValid = true;
    [...Object.values(victimAddFormValues)].forEach((el: any) => {
      const validator = victimValidator(el);
      setVictimValidation(validator);
      if (!formsAreValidated(validator ? validator : {})) {
        isFormValid = false;
      }
    });
    if (isFormValid) {
      const victimFormValues = [...Object.values(victimAddFormValues)].map(
        (el: any) => {
          return {
            ...el,
            itt: el.itt === '' ? null : el.itt,
            annualOfIncome: el.annualOfIncome === '' ? null : el.annualOfIncome,
            isExcluded: !!el.isExcluded,
            claimId,
            id: undefined,
            beneficiaries: el.beneficiaries.map((item: any) => ({
              ...item,
              funeralFees:
                item.funeralFees === '' ? undefined : item.funeralFees,
            })),
          };
        },
      );
      const formattedVictims = formatSagisVictimsForAddVictim(
        victimFormValues,
        claimResponsabilityRate,
        props.listings,
      );

      props.requestAddVictims(
        {
          victimsSagisToAdd: formattedVictims,
          victimsCorpoToAdd: victimFormValues,
          priorityReasonId: addPriorityReasonProfession(
            priorityReasonClaimId,
            !!victimFormValues.find((v: any) =>
              PROFESSION_CODES.includes(v.professionCode),
            ),
            props.listings,
          ),
          riskKey,
          claimNumber,
          claimId,
          isCourtMonitoringManager: false,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
        },
        successCallBackAddVictims,
      );
    }
  };

  const { currentTabIndex, labels = [] } = {
    currentTabIndex:
      props.currentGlobalTabManagerIndex ||
      claimTabs(renderTabsTitle(props))?.currentTabIndex,
    labels: claimTabs(renderTabsTitle(props))?.labels,
  };

  const successCallBackUpdate = () => {
    toast.success(translate(messages.updatedRequest, props));
    cleanCivilProceedingStates();
  };

  const handleOpenFeeNoteDialog = (payload: any) => {
    setIsDecisionFeeNote(true);
    setIsDialogOpen(payload);
  };
  const handleUpdateProceedingCivil = () => {
    const date = new Date(get(props.claimRecap, 'claim.lossDate'));
    const dayOfMonth = date.getDate();
    const lawyerJurisdictionAssignedCode = featureService.hasFeature(
      FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
    )
      ? getAssignedJurisdictionLawyerCode(
          get(props.listings, LISTINGS.MAPPING_LAWYER_JURISDICTION, []),
          civilProceedingInfo.town,
          dayOfMonth,
        )
      : '';
    props.requestUpdateCivilProceeding(
      {
        id: civilProceedingInfo.id,
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
        JudiciaryProcessInfo: {
          claimId: claimId,
          riskKey: riskKey,
          circonscription: civilProceedingInfo.circonscription,
          assignedLawyer: featureService.hasFeature(
            FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
          )
            ? lawyerJurisdictionAssignedCode
            : civilProceedingInfo.assignedLawyer,

          town: civilProceedingInfo.town,
          claimNumbers: claimNumber,
          updateSagisIntervenantProvision: featureService.hasFeature(
            FEATURES.EVOLUTION_P3,
          )
            ? false
            : true,
          opposingLawyer: civilProceedingInfo.opposingLawyer,
          jurisdictionDegreeId: civilProceedingInfo.jurisdictionDegreeId,
          receptionDate: civilProceedingInfo.receptionDate,
          hearingDate: civilProceedingInfo.hearingDate,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
          courtNumber: formatCourtFileNumber(civilProceedingInfo.courtNumber),
          victims: claimType.corporeal
            ? [...Object.values(victimFormValues)].map((el: any) => ({
                ...el,
                itt: el.itt === '' ? null : el.itt,
                isExcluded: !!el.isExcluded,
              }))
            : undefined,
          associatedVictims: claimType.corporeal ? associatedVictims : [],
          username: currentUserStorage.get().username,
          otherDamage:
            damage.otherProperties && claimType.material
              ? otherDamage
              : undefined,
          opposingParties: damage.adverseVehicles
            ? formatOpposingParties(
                Object.values(vehicleFormValues),
                riskId,
                claimNumber,
                claimId,
                props.listings?.compagnies,
              )
            : undefined,
          associatedOpposingParties:
            claimType.material && damage.adverseVehicles
              ? associatedOpposingParties
              : [],
          isCourtMonitoringManager: userPrivileges.userHasPrivilege(
            PRIVILEGES.ISCOURTMONITORINGMANAGER,
          ),
          status: ALL_STATUS.PENDING,
          creator: currentUserStorage.get().username,
        },
        documents: extractUpdatedDocument(civilProceedingDoc),
      },
      successCallBackUpdate,
    );
  };

  return (
    <Container>
      <StyledTopDiv>
        {get(props.claimRecap['claim'], ['suspicious']) &&
          featureService.hasFeature(FEATURES.FRAUDE_CORPO) && (
            <SuspiciousCard />
          )}
        {shouldShowVictimExcludedWarning(
          get(props.claimRecap, 'victims'),
          featureService.hasFeature(FEATURES.IS_VICTIM_EXCLUDED_FROM_COVERAGE),
        ) && (
          <WarningCard
            message={messages.victimExcludedFromCoverageWarningMessage}
          />
        )}
        {featureService.hasFeature(FEATURES.TRANSACTION) &&
          !isEmpty(props.victimDecisionFlow) && (
            <>
              {!isEmpty(
                getVictimNamesWithJudgement(
                  props.victimDecisionFlow,
                  get(props.claimRecap, ['victims'], []),
                ),
              ) && (
                <WarningCard
                  message={messages.warningJudiciaryTitle}
                  isWarning={true}
                  textParams={getVictimNamesWithJudgement(
                    props.victimDecisionFlow,
                    get(props.claimRecap, ['victims'], []),
                  )}
                />
              )}
              {!isEmpty(
                getVictimNamesWithTransaction(
                  props.victimDecisionFlow,
                  get(props.claimRecap, ['victims'], []),
                ),
              ) && (
                <WarningCard
                  message={messages.warningTransactionTitle}
                  isWarning={true}
                  textParams={getVictimNamesWithTransaction(
                    props.victimDecisionFlow,
                    get(props.claimRecap, ['victims'], []),
                  )}
                />
              )}
            </>
          )}

        <TopCard
          claimNumber={get(props.claimRecap['claim'], 'claimNumber', '')}
          claimRecap={props.claimRecap}
          sagisClaim={props.sagisClaim}
          inputProps={{ disableUnderline: true }}
          intl={props.intl}
          setDropDown={setDropDown}
          dropDown={dropDown}
          toggleDrawer={toggleDrawer}
          handleOpenCivilProceeding={handleOpenCivilProceeding}
          handleOpenDisclaimerWarrantyReasons={
            handleOpenDisclaimerWarrantyReasons
          }
          requestSagisClaimInfo={props.requestSagisClaimInfo}
          toggleDrawerAssignmentClaim={toggleDrawerAssignmentClaim}
          toggleAddVictimCard={toggleAddVictimCard}
          assignedLawyer={get(
            get(props.claimRecap, 'claim.assignment', []).filter(
              (el: any) => !isNil(el.assignedLawyer),
            ),
            '[0].assignedLawyer',
            null,
          )}
          setIsAssignmentDialogOpen={setIsAssignmentDialogOpen}
          setOpenIsSuspiciosClaimDialog={setIsSuspiciosClaimDialog}
          handleToggleImagineDocDrawer={handleToggleDrawer}
          resetSagisInfoClaim={props.resetSagisInfoClaim}
          claimHasCivilPartyJudiciaryProcess={{}}
          handleToggleTrackingDrawer={handleToggleTrackingDrawer}
          requestSetStatusClaimSagis={props.requestSetStatusClaimSagis}
          isConsultation={false}
          listings={props.listings}
          handleResetStore={handleResetStore}
        />
      </StyledTopDiv>
      {featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER) && (
        <TrackingActionDrawer
          isDrawerOpen={openTrackingDrawer}
          setIsDrawerOpen={handleToggleTrackingDrawer}
          userActions={props.userActions}
          listings={props.listings}
          claimHistorySagis={props.claimHistorySagis}
          claimNumber={claimNumber}
          claimId={claimId}
          requestGetClaimHistoryActions={props.requestGetClaimHistoryActions}
          requestGetClaimHistorySagis={props.requestGetClaimHistorySagis}
          loaders={props.loaders}
        />
      )}

      {featureService.hasFeature(FEATURES.FEE_NOTE) && (
        <DialogFeeNote
          allFeeNote={props.allFeeNote}
          requestAllFeeNotes={props.requestAllFeeNotes}
          feeNotes={filterFeeNotes(
            props.feeNotes,
            isExpertFeeNote,
            props.decisionJudgementIds,
            isDecisionFeeNote,
          )}
          feeNotesCount={props.feeNotesCount}
          requestLawyerFeeNotes={props.requestFeeNotesByClaimNumb}
          requestCreateFeeNote={props.requestCreateFeeNote}
          requestFeeNoteCosts={props.requestFeeNoteExceptionalCosts}
          keyclokToken={props.keyclokToken}
          resetUploadDocumentStore={props.resetUploadDocumentStore}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          makeDecisionFeeNote={props.makeDecisionFeeNote}
          open={isDialogOpen}
          handleClose={handleClose}
          showButtonAdd={false}
          title={translate(messages.FeeNoteTitle, props)}
          claimNumber={get(props.claimRecap, 'claim.claimNumber')}
          listings={props.listings}
          page={page}
          setPage={setPage}
          linkToBeneficiaryCodes={props.linkToBeneficiaryCodes}
          isExpert={isExpertFeeNote}
          requestUpdateFeeNoteAmount={props.requestUpdateFeeNoteAmount}
          loaders={props.loaders}
          requestAddInvoiceFeeNote={props.requestAddInvoiceFeeNote}
          requestUpdateInvoiceFeeNote={props.requestUpdateInvoiceFeeNote}
          requestUpdateFeeNoteStatus={props.requestUpdateFeeNoteStatus}
          contractorFeesSagis={get(props.sagisClaim, 'contractorFees')}
          isConsultation={false}
          requestUpdateFirmReferenceManager={
            props.requestUpdateFirmReferenceManager
          }
        />
      )}
      {isDrawerOpen && (
        <AssignExpertDrawer
          open={isDrawerOpen}
          handleToggleDrawer={toggleDrawer}
          listings={props.listings}
          victims={filterVictim(get(props.claimRecap, 'victims', []))}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          resetUploadedDocument={props.resetUploadDocumentStore}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          requestAssignedExpert={props.requestAssignedExpert}
          claimId={claimId}
          claimNumber={claimNumber}
          judiciaryProcessId={idCivilProceeding}
          courtFileNumber={getCourtFileNumber(
            props.civilProceeding,
            idCivilProceeding,
            props.judgementAdd,
          )}
          requestCorporealLawyers={props.requestCorporealLawyers}
          corporealLawyers={props.corporealLawyers}
          assignedLawyer={get(
            props.claimRecap,
            'claim.assignment[0].assignedLawyer',
          )}
          searchQuery={{}}
          civilProceeding={props.civilProceeding}
          corporealExperts={[]}
          requestGetExpertUsers={() => {}}
          vehicles={filterVehicle(get(props.claimRecap, 'vehicules', []))}
          requestGetCivilProceeding={props.requestGetCivilProceeding}
          selectedSearchResult={{}}
          claimHasCivilPartyJudiciaryProcess={{}}
          riskKey={riskKey}
          claimRecap={props.claimRecap}
        />
      )}

      {isSuspiciosClaimDialog &&
        featureService.hasFeature(FEATURES.FRAUDE_CORPO) && (
          <SuspiciosClaimDialog
            open={isSuspiciosClaimDialog}
            claimId={claimId}
            onClose={() => setIsSuspiciosClaimDialog(false)}
            validateDialog={(payload: any, successCallBack: Function) =>
              props.requestIsSuspiciosClaim(payload, successCallBack)
            }
          />
        )}
      {featureService.hasFeature(FEATURES.CIVIL_PROCEEDING) && (
        <DialogCivilProceeding
          open={isDialogOpenCivilProceeding}
          title={
            procedureType === 2
              ? translate(messages.civilProceedingTitle, props)
              : translate(messages.commercialproceedingTitle, props)
          }
          handleClose={handleCloseCivilProceeding}
          confirmTitle={
            updateCivilProcedure
              ? translate(messages.updateTitle, props)
              : translate(messages.civilAdd, props)
          }
          cancelTitle={translate(messages.civilCancel, props)}
          handleValidate={
            updateCivilProcedure
              ? handleUpdateProceedingCivil
              : handleValidateProceedingCivil
          }
          disablePrimaryButton={disabledPrimaryButton(
            claimType,
            associatedVictims,
            victimFormValues,
            associatedOpposingParties,
            vehicleFormValues,
            civilProceedingInfo,
          )}
          children={
            <CivilProceedingForm
              resetUploadedDocument={props.resetUploadDocumentStore}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              civilProceedingDoc={civilProceedingDoc}
              setCivilProceedingDoc={setCivilProceedingDoc}
              victimsInfo={victimsInfo}
              setVictimsInfo={setVictimsInfo}
              setDocumentId={props.setDocumentId}
              documentId={props.documentId}
              civilProceedingInfo={civilProceedingInfo}
              setCivilProceedingInfo={setCivilProceedingInfo}
              victims={filterVictim(get(props.claimRecap, 'victims', []))}
              vehicles={filterVehicle(get(props.claimRecap, 'vehicules', []))}
              listings={props.listings}
              requestCorporealLawyers={props.requestCorporealLawyers}
              corporealLawyers={props.corporealLawyers}
              claimId={claimId}
              damage={damage}
              setDamage={setDamage}
              claimType={claimType}
              setClaimType={setClaimType}
              otherDamage={otherDamage}
              handleChangeOtherDamage={handleChangeOtherDamage}
              vehicleFormValues={vehicleFormValues}
              setVehicleFormValues={setVehicleFormValues}
              addVehicleForm={addVehicleForm}
              victimFormValues={victimFormValues}
              setVictimFormValues={setVictimFormValues}
              addVictimForm={addVictimForm}
              associatedVictims={associatedVictims}
              setAssociatedVictims={setAssociatedVictims}
              associatedOpposingParties={associatedOpposingParties}
              setAssociatedOpposingParties={setAssociatedOpposingParties}
              lossDate={get(props.claimRecap, 'claim.lossDate')}
              victimValidation={victimValidation}
              sagisVictimInfo={get(props.sagisClaim, 'victims', [])}
              sagisOpposingParties={extractOpposingParties(
                get(props.sagisClaim, 'offeredRisks', []),
              )}
              claimRecap={props.claimRecap}
            />
          }
        />
      )}
      {featureService.hasFeature(FEATURES.TRAITEMENT_IMAGINE_DOC) && (
        <ImagineDocumentsDrawer
          isDrawerOpen={OpenDrawerImagineDocuments}
          setIsDrawerOpen={setOpenDraweImagineDocuments}
          listings={props.listings}
          expandRow={expandRow}
          setExpandRow={setExpandRow}
          claimSagisInfo={resolveSagisClaim(props.policyInfo)}
          managerNotifcationsInboxes={get(
            props.pendingTasksClaim,
            'pendingNotifications',
            [],
          )}
          claimId={claimId}
          shouldDisplayUploadDocument={true}
          requestMakeDecisionsDocumentImaging={
            props.requestMakeDecisionsDocumentImaging
          }
          requestGetNotificationsInboxes={props.requestGetNotificationsInboxes}
          isConsultation={false}
          imagineNotification={props.imagineNotification}
          claimNumber={claimNumber}
          requestUploadDocumentManager={props.requestUploadDocumentManager}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      )}
      {featureService.hasFeature(FEATURES.DISCLAIMER_WARRANTY) && (
        <DialogDisclaimerWarranty
          open={isWarrantyDialogOpen}
          confirmTitle={translate(messages.validateWarrantyReason, props)}
          cancelTitle={translate(messages.cancelWarrantyReason, props)}
          handleClose={handleCloseWarrantyDialog}
          handleValidate={handleValidateWarrantyDialog}
          title={translate(messages.ExlusionOfWarranty, props)}
          listings={props.listings}
        />
      )}
      {featureService.hasFeature(FEATURES.INSTRUCTIONS) && (
        <InstructionDrawer
          open={isInstructionDrawerOpen}
          handleToggleDrawer={toggleDrawerInstruction}
          listings={props.listings}
          judiciaryProcess={props.civilProceeding}
          intervenants={get(props.listings, 'intervenants', [])}
          claimRecap={props.claimRecap}
          isManager
          setIsInstructionDrawerOpen={setIsInstructionDrawerOpen}
          judiciaryProcessId={
            idCivilProceeding
              ? idCivilProceeding
              : props.currentJudiciaryProccessId
          }
          claimId={claimId}
          isConsultation={false}
          instructions={props.instructions}
          requestCreateInstruction={props.requestCreateInstruction}
          requestGetInstructions={props.requestGetInstructions}
          instruction={instruction}
          setInstruction={setInstruction}
          isIntervenant={false}
        />
      )}
      {featureService.hasFeature(FEATURES.ASSIGNMENT_CLAIM) && (
        <>
          <AssignmentClaimDrawer
            open={isAssignmentClaimDrawerOpen}
            handleToggleDrawer={toggleDrawerAssignmentClaim}
            listings={props.listings}
            judiciaryProcess={props.civilProceeding}
            intervenants={get(props.listings, 'intervenants', [])}
            claimRecap={props.claimRecap}
            setIsAssignmentDialogOpen={setIsAssignmentDialogOpen}
            setJudiciaryProcessType={setJudiciaryProcessType}
            judiciaryProcessId={idCivilProceeding}
            setIsReassignmentManager={setIsReassignmentManager}
            isConsultation={false}
          />
          <AssignmentDialog
            open={isAssignmentDialogOpen}
            onClose={handleCloseAssignmentDialog}
            subServices={get(props.listings, LISTINGS.SUB_SERVICES, [])}
            zonesCodes={get(props.listings, LISTINGS.ZONE_CODES, [])}
            services={get(props.listings, LISTINGS.SERVICES, [])}
            stackholders={get(props.listings, LISTINGS.STACKHOLDERS, [])}
            stackholderTypes={get(
              props.listings,
              LISTINGS.STACKHOLDER_TYPE,
              [],
            )}
            requestAssigment={props.requestAssigment}
            claim={(props.claimRecap.claim as unknown) as Claim}
            requestCorporealLawyers={props.requestCorporealLawyers}
            corporealLawyers={props.corporealLawyers}
            shouldAssignOnSagis={false}
            isManagerOpenedClaimsPage={false}
            listings={props.listings}
            claimNumber={get(props.claimRecap['claim'], 'claimNumber', '')}
            judiciaryProcessType={judiciaryProcessType}
            isReassignmentManager={isReassignmentManager}
            judiciaryProcessId={
              idCivilProceeding
                ? idCivilProceeding
                : props.currentJudiciaryProccessId
            }
            judgementAdd={props.judgementAdd}
            judgementOnMerits={props.judgementOnMerits}
            judgementAppeal={props.judgementAppeal}
            judgementAddAppeal={props.judgementAddAppeal}
            civilProceeding={props.civilProceeding}
            riskKey={riskKey}
            isClaim
          />
        </>
      )}
      {(userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER) ||
        (featureService.hasFeature(FEATURES.EVOLUTION_P4) &&
          userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER))) && (
        <DialogCivilProceeding
          open={isAddVictimCardOpen}
          title={translate(messages.addVictim, props)}
          handleClose={() => toggleAddVictimCard()}
          confirmTitle={translate(messages.civilAdd, props)}
          cancelTitle={translate(messages.civilCancel, props)}
          handleValidate={validateVictimCardForm}
          disablePrimaryButton={disabledDialogAddVictim(
            victimAddFormValues,
            props.claimRecap,
          )}
          children={
            <VictimFormComponent
              victimFormValues={victimAddFormValues}
              setVictimFormValues={setVictimAddFormValues}
              addVictimForm={addVictimCardForm}
              claimId={claimId}
              listings={props.listings}
              victimValidation={victimValidation}
              claimRecap={props.claimRecap}
            />
          }
        />
      )}
      {featureService.hasFeature(FEATURES.CIVIL_PROCEEDING) && (
        <SahamTabsGlobal>
          <GlobalLegalProceedingTabs
            currentTabIndex={currentTabIndex}
            labels={labels}
            setCurrentInstanceTab={props.setCurrentInstanceTab}
          >
            <ClaimRecap
              listings={props.listings}
              storedClaimToPreopen={props.storedClaimToPreopen}
              requestClaimRecap={props.requestClaimRecap}
              claimRecap={props.claimRecap}
              policyInfo={props.policyInfo}
              requestSearchClaims={props.requestSearchClaims}
              resetSearchClaimsStore={props.resetSearchClaimsStore}
              claimId={claimId}
              shouldDisplayBreadCrumbs={false}
              className="recap-bloc"
              shouldNotGetClaim
              stakeholders={stakeholders}
              requestUpdateVictimInfo={props.requestUpdateVictimInfo}
              requestUpdateBeneficiaryInfo={props.requestUpdateBeneficiaryInfo}
              requestUpdateVehicleInfo={props.requestUpdateVehicleInfo}
              setClaimRecap={props.setClaimRecap}
              requestCreateVehicle={props.requestAddVehicles}
              requestCreateVictim={props.requestAddVictims}
              isCourtManager={userPrivileges.userHasPrivilege(
                PRIVILEGES.ISCOURTMANAGER,
              )}
              requestUpdateClaim={props.requestUpdateClaim}
              resetUploadedDocument={props.resetUploadDocumentStore}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              setDocumentId={props.setDocumentId}
              documentId={props.documentId}
              requestSagisClaimInfo={props.requestSagisClaimInfo}
              sagisInfo={props.sagisClaim}
              keycloakToken={props.keyclokToken}
              requestGetReportsPolicy={props.requestGetReportsPolicy}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
              requestUpdateFraudInfo={props.requestUpdateFraudInfo}
            />
            <JudiciaryProcessTabs
              currentTabIndex={getCurrentTabJudiciaryProcess(
                props.currentJudiciaryProccessId,
                props.civilProceeding,
              )}
              labels={labes}
              handleClickVerticalTabs={handleClickVerticalTabs}
            >
              {labes.map((label, index) => {
                return (
                  <ManagerLegalProceedingsPage
                    currentJudiciaryProcess={
                      currentJudiciaryProcess
                        ? currentJudiciaryProcess
                        : props.currentJudiciaryProccessId
                    }
                    listings={props.listings}
                    onPressFeeNote={handleOpen}
                    onPressAssignment={handleOpenAssignment}
                    onPressInstructions={handleOpenInstructions}
                    storedClaimToPreopen={props.storedClaimToPreopen}
                    requestClaimRecap={props.requestClaimRecap}
                    getLegalProceedingsSteps={props.getLegalProceedingsSteps}
                    claimRecap={props.claimRecap}
                    currentSteps={props.currentSteps}
                    policyInfo={props.policyInfo}
                    requestSearchClaims={props.requestSearchClaims}
                    resetSearchClaimsStore={props.resetSearchClaimsStore}
                    match={props.match}
                    requestGetJudgementAdd={props.requestGetJudgementAdd}
                    judgementAdd={props.judgementAdd}
                    requestGetJudgementAddAppeal={
                      props.requestGetJudgementAddAppeal
                    }
                    judgementAddAppeal={props.judgementAddAppeal}
                    requestMakeJudgementAddDecision={
                      props.requestMakeJudgementAddDecision
                    }
                    requestGetExpertiseRaport={props.requestGetExpertiseRaport}
                    expertiseReport={props.expertiseReport}
                    requestValidateExpertReport={
                      props.requestValidateExpertReport
                    }
                    uploadDocument={props.uploadDocument}
                    uploadedDocument={props.uploadedDocument}
                    resetUploadedDocument={props.resetUploadDocumentStore}
                    requestValidateJudgementOnMerits={
                      props.requestValidateJudgementOnMerits
                    }
                    requestGetJudgementOnMerits={
                      props.requestGetJudgementOnMerits
                    }
                    requestGetJudgementOnMeritsAppeal={
                      props.requestGetJudgementOnMeritsAppeal
                    }
                    judgementOnMeritsAppeal={props.judgementOnMeritsAppeal}
                    expertiseRaportAppeal={props.expertiseRaportAppeal}
                    requestGetExpertiseReportAppeal={
                      props.requestGetExpertiseReportAppeal
                    }
                    judgementOnMerits={props.judgementOnMerits}
                    documentId={props.documentId}
                    setDocumentId={props.setDocumentId}
                    judgementAppeal={props.judgementAppeal}
                    requestGetJudgementAppeal={props.requestGetJudgementAppeal}
                    requestValidateJudgementAppeal={
                      props.requestValidateJudgementAppeal
                    }
                    requestGetDahirAmount={props.requestGetDahirAmount}
                    dahirAmount={props.dahirAmount}
                    feeNotes={props.feeNotes}
                    feeNotesCount={props.feeNotesCount}
                    resetUploadDocumentStore={props.resetUploadDocumentStore}
                    requestManagerFeeNotes={props.requestManagerFeeNotes}
                    requestFeeNotesByClaimNumb={
                      props.requestFeeNotesByClaimNumb
                    }
                    requestCreateFeeNote={props.requestCreateFeeNote}
                    keyclokToken={props.keyclokToken}
                    makeDecisionFeeNote={props.makeDecisionFeeNote}
                    currentTabInstance={props.currentTabInstance}
                    setCurrentInstanceTab={props.setCurrentInstanceTab}
                    requestAllFeeNotes={props.requestAllFeeNotes}
                    allFeeNote={props.allFeeNote}
                    requestCorporealLawyers={props.requestCorporealLawyers}
                    corporealLawyers={props.corporealLawyers}
                    requestCreateCivilProceeding={
                      props.requestCreateCivilProceeding
                    }
                    requestGetCivilProceeding={props.requestGetCivilProceeding}
                    judiciaryProcessId={
                      idCivilProceeding
                        ? idCivilProceeding
                        : props.currentJudiciaryProccessId
                    }
                    civilProceeding={props.civilProceeding}
                    requestCreateJudgementOnMerits={
                      props.requestCreateJudgementOnMerits
                    }
                    requestUpdatedCivilProceeding={
                      props.requestUpdatedCivilProceeding
                    }
                    requestSagisClaimInfo={props.requestSagisClaimInfo}
                    sagisClaim={props.sagisClaim}
                    requestGetDahirAmountCorpo={
                      props.requestGetDahirAmountCorpo
                    }
                    dahirAmountsCorpo={props.dahirAmountsCorpo}
                    requestCreateJudgementOnMeritsContestation={
                      props.requestCreateJudgementOnMeritsContestation
                    }
                    requestValidatedCivilProceeding={
                      props.requestValidatedCivilProceeding
                    }
                    requestMakeJudgementAddDocumentDecision={
                      props.requestMakeJudgementAddDocumentDecision
                    }
                    updateContestation={props.updateContestation}
                    requestUploadContestationDocument={
                      props.requestUploadContestationDocument
                    }
                    requestUpdateVictimInfo={props.requestUpdateVictimInfo}
                    requestUpdateBeneficiaryInfo={
                      props.requestUpdateBeneficiaryInfo
                    }
                    requestUpdateVehicleInfo={props.requestUpdateVehicleInfo}
                    setClaimRecap={props.setClaimRecap}
                    requestAddVictims={props.requestAddVictims}
                    requestGetAppealOnMeritsMultiple={
                      props.requestGetAppealOnMeritsMultiple
                    }
                    requestGetJudgementOnMeritsMultiple={
                      props.requestGetJudgementOnMeritsMultiple
                    }
                    appealOnMeritsMultiple={props.appealOnMeritsMultiple}
                    judgementOnMeritsMultiple={props.judgementOnMeritsMultiple}
                    judgementOnMeritsByVictims={
                      props.judgementOnMeritsByVictims
                    }
                    requestGetJudgementOnMeritsByVictims={
                      props.requestGetJudgementOnMeritsByVictims
                    }
                    judgementOnMeritsByVehicles={
                      props.judgementOnMeritsByVehicles
                    }
                    requestGetJudgementOnMeritsByVehicles={
                      props.requestGetJudgementOnMeritsByVehicles
                    }
                    expertExpertise={props.expertExpertise}
                    requestMakeDecisionMissionExpertise={
                      props.requestMakeDecisionMissionExpertise
                    }
                    loaders={props.loaders}
                    requestCreateJudgementAdd={props.requestCreateJudgementAdd}
                    requestCreateMultipleJudgementAdd={
                      props.requestCreateMultipleJudgementAdd
                    }
                    requestCreateExpertiseRaport={
                      props.requestCreateExpertiseRaport
                    }
                    currentIndexTabManager={props.currentIndexTabManager}
                    currentInstanceTabIndexManager={
                      props.currentInstanceTabIndexManager
                    }
                    currentJudiciaryProccessId={
                      props.currentJudiciaryProccessId
                    }
                    requestAddSupportDocument={props.requestAddSupportDocument}
                    requestCivilPartySupportDocument={
                      props.requestCivilPartySupportDocument
                    }
                    requestAddExpertiseSupportDocument={
                      props.requestAddExpertiseSupportDocument
                    }
                    requestAddJudgementOnMeritsSupportDocument={
                      props.requestAddJudgementOnMeritsSupportDocument
                    }
                    currentGlobalTabManagerIndex={
                      props.currentGlobalTabManagerIndex
                    }
                    setIsButtonRedirect={setIsButtonRedirect}
                    isButtonRedirect={isButtonRedirect}
                    setOpenFeeNoteDialog={handleOpenFeeNoteDialog}
                    resetStoreClaim={props.resetStoreClaim}
                    resetSagisInfoClaim={props.resetSagisInfoClaim}
                    resetLegalProceeding={props.resetSagisInfoClaim}
                    instructions={props.instructions}
                    requestCreateIncomeCertificate={
                      props.requestCreateIncomeCertificate
                    }
                    requestUpdateIncomeCertificate={
                      props.requestUpdateIncomeCertificate
                    }
                    requestSetPriorityClaimProvision={
                      props.requestSetPriorityClaimProvision
                    }
                    requestGetReportsPolicy={props.requestGetReportsPolicy}
                    requestMakeDecisionIncomeCertificate={
                      props.requestMakeDecisionIncomeCertificate
                    }
                    requestMakeDecisionSupportDocument={
                      props.requestMakeDecisionSupportDocument
                    }
                    imagineDocuments={get(
                      props.pendingTasksClaim,
                      'pendingNotifications',
                      [],
                    )}
                    requestGetClaimCivilParty={props.requestGetClaimCivilParty}
                    claimCivilParty={props.claimCivilParty}
                    setNotification={props.setNotification}
                    requestArchiveJudgement={props.requestArchiveJudgement}
                    requestUploadDocumentManager={
                      props.requestUploadDocumentManager
                    }
                    requestGetDocByDocumentumId={
                      props.requestGetDocByDocumentumId
                    }
                    requestGetJudgements={props.requestGetJudgements}
                    handleOpenUpdateFormCivilProceeding={
                      handleOpenUpdateFormCivilProceeding
                    }
                  />
                );
              })}
            </JudiciaryProcessTabs>
            {get(
              renderTabsTitle(props)['PROVISION_AND_REGULATION'],
              'feature',
              false,
            ) && (
              <ProvisionRegulationContainer
                listings={props.listings}
                claimRecap={props.claimRecap}
                uploadedDocument={props.uploadedDocument}
                sagisClaim={props.sagisClaim}
                judgementOnMeritsByVictims={props.judgementOnMeritsByVictims}
                regulations={props.regulations}
                currentRegulationPath={props.currentRegulationPath}
                uploadDocument={props.uploadDocument}
                requestSagisClaimInfo={props.requestSagisClaimInfo}
                requestGetRegulations={props.requestGetRegulations}
                requestCreateFeeNoteManager={props.requestCreateFeeNoteManager}
                claimNumber={claimNumber}
                claimId={claimId}
                policyInfo={props.policyInfo}
                dahirAmount={props.dahirAmount}
                dahirAmountsCorpo={props.dahirAmountsCorpo}
                resetUploadDocumentStore={props.resetUploadDocumentStore}
                requestGetDahirAmount={props.requestGetDahirAmount}
                requestGetJudgementOnMeritsByVictims={
                  props.requestGetJudgementOnMeritsByVictims
                }
                requestGetJudgementOnMeritsByVehicles={
                  props.requestGetJudgementOnMeritsByVehicles
                }
                requestCreateCorpoEncryptedDocument={
                  props.requestCreateCorpoEncryptedDocument
                }
                corporealEncryptedDocuments={props.corporealEncryptedDocuments}
                requestCreateCorporealRegulation={
                  props.requestCreateCorporealRegulation
                }
                requestCreateMaterialRegulation={
                  props.requestCreateMaterialRegulation
                }
                requestCreateAdditionalWarrentiesRegulation={
                  props.requestCreateAdditionalWarrentiesRegulation
                }
                requestMaterialEncryptedDocument={
                  props.requestMaterialEncryptedDocument
                }
                materialEncryptedDocuments={props.materialEncryptedDocuments}
                requestGetAssignedLawyers={props.requestGetAssignedLawyers}
                assignedLawyers={props.assignedLawyers}
                requestGetDahirAmountCorpo={props.requestGetDahirAmountCorpo}
                requestValidateProvisionIntervenant={
                  props.requestValidateProvisionIntervenant
                }
                createdRegulations={props.createdRegulations}
                requestCreateSummarySheetRegulation={
                  props.requestCreateSummarySheetRegulation
                }
                uploadDocumentRegulation={props.uploadDocumentRegulation}
                corpoRegulations={props.regulations}
                requestValidateProvision={props.requestValidateProvision}
                judgementOnMeritsByVehicles={props.judgementOnMeritsByVehicles}
                match={props.match}
                resetSearchClaimsStore={props.resetSearchClaimsStore}
                resetStoreClaim={props.resetStoreClaim}
                resetSagisInfoClaim={props.resetSagisInfoClaim}
                resetLegalProceeding={props.resetLegalProceeding}
                setLockedClaim={props.setLockedClaim}
                requestLockClaim={props.setLockedClaim}
                requestResetHistoryStore={props.setLockedClaim}
                requestUnlockClaim={props.setLockedClaim}
                requestSearchClaims={props.requestSearchClaims}
                isCourtManagerBasicManagementRegulation={featureService.hasFeature(
                  FEATURES.BASIC_MANAGEMENT_REGULATION,
                )}
                requestCreateStakeHolder={props.requestCreateStakeHolder}
              />
            )}
            {get(
              renderTabsTitle(props)['EXPERT_INTEGRATION'],
              'feature',
              false,
            ) && (
              <ExpertiseExpert
                match={props.match}
                requestMakeDecisionMissionExpertise={
                  props.requestMakeDecisionMissionExpertise
                }
                requestMakeDecisionMissionNoticeDeficiency={
                  props.requestMakeDecisionMissionNoticeDeficiency
                }
                requestFeeNotesByClaimNumb={props.requestFeeNotesByClaimNumb}
                claimNumber={claimNumber}
                onPressFeeNote={handleOpenExpertiseFeeNote}
                currentTabManagerExpertise={props.currentTabManagerExpertise}
                riskKey={riskKey}
                setOpenFeeNoteDialog={handleOpenFeeNoteDialog}
                claimRecap={props.claimRecap}
                resetSearchClaimsStore={props.resetSearchClaimsStore}
                resetStoreClaim={props.resetStoreClaim}
                resetSagisInfoClaim={props.resetSagisInfoClaim}
                resetLegalProceeding={props.resetLegalProceeding}
                policyInfo={props.policyInfo}
                currentIndexTabManager={props.currentIndexTabManager}
                currentInstanceTabIndexManager={
                  props.currentInstanceTabIndexManager
                }
                currentTabInstance={props.currentTabInstance}
                requestSearchClaims={props.requestSearchClaims}
                requestSetPriorityClaimProvision={
                  props.requestSetPriorityClaimProvision
                }
                listings={props.listings}
                requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
                requestGetExpertiseVictim={props.requestGetExpertiseVictim}
              />
            )}
            {get(renderTabsTitle(props)['TRANSACTION'], 'feature', false) && (
              <Transaction
                match={props.match}
                claimNumber={claimNumber}
                claimRecap={props.claimRecap}
                resetSearchClaimsStore={props.resetSearchClaimsStore}
                resetStoreClaim={props.resetStoreClaim}
                resetSagisInfoClaim={props.resetSagisInfoClaim}
                resetLegalProceeding={props.resetLegalProceeding}
                policyInfo={props.policyInfo}
                requestSearchClaims={props.requestSearchClaims}
                requestGetTransaction={props.requestGetTransaction}
                requestAddTransaction={props.requestAddTransaction}
                uploadedDocument={props.uploadedDocument}
                resetUploadedDocument={props.resetUploadDocumentStore}
                uploadDocument={props.uploadDocument}
                requestUpdateTransaction={props.requestUpdateTransaction}
                requestAddContactTransaction={
                  props.requestAddContactTransaction
                }
                requestGetContactTransaction={
                  props.requestGetContactTransaction
                }
                resetStoreTransaction={props.resetStoreTransaction}
                requestUpdateContactTransaction={
                  props.requestUpdateContactTransaction
                }
                corporealExperts={[]}
                requestGetExpertUsers={() => {}}
                requestAssignedExpert={props.requestAssignedExpert}
                riskKey={riskKey}
                requestGetMissionTransaction={
                  props.requestGetMissionTransaction
                }
                requestMakeDecisionMissionExpertise={
                  props.requestMakeDecisionMissionExpertise
                }
                requestGetMissionVictimExpertise={
                  props.requestGetMissionVictimExpertise
                }
                requestUpdateMissionTransaction={
                  props.requestUpdateMissionTransaction
                }
                requestGetFeeNotesTransaction={
                  props.requestGetFeeNotesTransaction
                }
                onPressFeeNote={() => {}}
                isConsultation={true}
                expertJudiciaryExpertise={props.expertExpertise}
                requestImportMissionExpertise={() => {}}
                requestGetJudiciaryExpertReport={() => {}}
                requestMakeDecisionVictimInfo={() => {}}
                sagisInfo={props.sagisClaim}
                requestLockClaim={props.requestLockClaim}
                setLockedClaim={props.setLockedClaim}
                requestSetPriorityClaimProvision={
                  props.requestSetPriorityClaimProvision
                }
                requestResetHistoryStore={props.requestResetHistoryStore}
                currentIndexTabManager={props.requestResetHistoryStore}
                currentInstanceTabIndexManager={
                  props.currentInstanceTabIndexManager
                }
                currentGlobalTabManagerIndex={
                  props.currentGlobalTabManagerIndex
                }
                currentJudiciaryProccessId={props.currentJudiciaryProccessId}
                requestGetDahirAmount={props.requestGetDahirAmount}
                setCurrentIndexTabTransaction={
                  props.setCurrentIndexTabTransaction
                }
                requestCreateCorporealRegulation={() => {}}
                requestGetRegulations={props.requestGetRegulations}
                regulations={props.regulations}
                requestSagisClaimInfo={props.requestSagisClaimInfo}
                requestGetRegulation={props.requestGetRegulation}
                requestValidateRegulation={() => {}}
                requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
              />
            )}
          </GlobalLegalProceedingTabs>
        </SahamTabsGlobal>
      )}
    </Container>
  );
};

const mapDispatchToProps = {
  requestUpdateVictimInfo,
  requestClaimRecap,
  requestSearchClaims,
  getLegalProceedingsSteps,
  resetSearchClaimsStore,
  requestGetJudgementAdd,
  requestMakeJudgementAddDecision,
  requestGetExpertiseRaport,
  requestValidateExpertReport,
  requestValidateJudgementOnMerits,
  requestGetJudgementOnMerits,
  requestGetJudgementOnMeritsAppeal,
  requestGetExpertiseReportAppeal,
  uploadDocument,
  resetUploadDocumentStore,
  requestGetJudgementAppeal,
  requestValidateJudgementAppeal,
  requestGetDahirAmount,
  setDocumentId,
  requestManagerFeeNotes,
  requestCreateFeeNote,
  requestFeeNoteExceptionalCosts,
  requestFeeNotesByClaimNumb,
  makeDecisionFeeNote,
  setCurrentInstanceTab,
  requestAllFeeNotes,
  requestCorporealLawyers,
  requestCreateCivilProceeding,
  requestGetCivilProceeding,
  requestGetJudgementAddAppeal,
  requestCreateJudgementOnMerits,
  requestAssignedExpert,
  requestValidateDisclaimerWarranty,
  requestUpdatedCivilProceeding,
  requestValidatedCivilProceeding,
  requestSagisClaimInfo,
  requestGetDahirAmountCorpo,
  requestCreateJudgementOnMeritsContestation,
  requestMakeJudgementAddDocumentDecision,
  requestAssigment,
  requestAddVictims,
  updateContestation,
  requestUploadContestationDocument,
  requestUpdateBeneficiaryInfo,
  requestUpdateVehicleInfo,
  setClaimRecap,
  requestAddVehicles,
  requestGetAppealOnMeritsMultiple,
  requestGetJudgementOnMeritsMultiple,
  requestGetJudgementOnMeritsByVictims,
  requestGetJudgementOnMeritsByVehicles,
  requestGetExpertiseVictim,
  requestMakeDecisionMissionExpertise,
  requestMakeDecisionMissionNoticeDeficiency,
  requestCreateCorpoEncryptedDocument,
  requestCreateCorporealRegulation,
  requestCreateMaterialRegulation,
  requestCreateAdditionalWarrentiesRegulation,
  requestUpdateFeeNoteAmount,
  requestMaterialEncryptedDocument,
  requestIsSuspiciosClaim,
  requestCreateJudgementAdd,
  requestGetAssignedLawyers,
  requestCreateMultipleJudgementAdd,
  requestCreateExpertiseRaport,
  requestUpdateClaim,
  requestAddSupportDocument,
  requestCivilPartySupportDocument,
  requestAddExpertiseSupportDocument,
  requestAddJudgementOnMeritsSupportDocument,
  requestValidateProvisionIntervenant,
  requestLockClaim,
  requestUnlockClaim,
  setLockedClaim,
  requestGetRegulations,
  resetStoreClaim,
  resetSagisInfoClaim,
  resetLegalProceeding,
  requestCreateSummarySheetRegulation,
  uploadDocumentRegulation,
  requestMakeDecisionsDocumentImaging,
  requestGetNotificationsInboxes,
  requestAddInvoiceFeeNote,
  requestValidateProvision,
  requestUpdateInvoiceFeeNote,
  requestGetClaimHistoryActions,
  requestUpdateFeeNoteStatus,
  setDecisionsJudgementIds,
  requestGetClaimHistorySagis,
  requestSetStatusClaimSagis,
  requestCreateStakeHolder,
  requestSetPriorityClaimProvision,
  requestGetInstructions,
  requestCreateInstruction,
  requestResetHistoryStore,
  requestCreateFeeNoteManager,
  requestCreateIncomeCertificate,
  requestUpdateIncomeCertificate,
  requestGetFeeNotesTransaction,
  requestGetTransaction,
  requestAddTransaction,
  resetStoreTransaction,
  requestUpdateTransaction,
  requestAddContactTransaction,
  requestGetContactTransaction,
  requestGetMissionTransaction,
  requestGetMissionVictimExpertise,
  requestUpdateContactTransaction,
  requestUpdateMissionTransaction,
  requestGetReportsPolicy,
  requestMakeDecisionIncomeCertificate,
  requestMakeDecisionSupportDocument,
  requestGetPendingTasksClaim,
  requestGetClaimCivilParty,
  setCurrentIndexTabTransaction,
  setNotification,
  requestArchiveJudgement,
  requestUploadDocumentManager,
  requestUpdateFraudInfo,
  requestGetDocByDocumentumId,
  requestGetJudgements,
  requestUpdateFirmReferenceManager,
  requestGetRegulation,
  requestGetDecisionFlowVictims,
  requestUpdateInstruction,
  requestUpdateCivilProceeding,
};

const mapStateToProps = createStructuredSelector({
  listings: makeSelectListings(),
  claimRecap: makeSelecClaimRecap(),
  policyInfo: makeSelectSearchClaims(),
  uploadedDocument: makeSelectDocument(),
  judgementAdd: makeSelectJudgementAdd(),
  currentSteps: makeSelectLegalProceedingsSteps(),
  expertiseReport: makeSelectExpertiseRaport(),
  judgementAddAppeal: makeSelectJudgementAddAppeal(),
  expertiseRaportAppeal: makeSelectExpertiseRaportAppeal(),
  judgementOnMerits: makeSelectJudgementOnMerits(),
  judgementOnMeritsAppeal: makeSelectJudgementOnMeritsAppeal(),
  judgementAppeal: makeSelectJudgementAppeal(),
  dahirAmount: makeSelectDahirAmounts(),
  documentId: makeSelectDocumentId(),
  feeNotes: makeSelectFeeNotes(),
  feeNotesCount: makeSelectCountFeeNotes(),
  keyclokToken: makeSelectKeycloakToken(),
  currentTabInstance: makeSelectCurrentInstanceTab(),
  allFeeNote: makeSelectAllFeeNotes(),
  corporealLawyers: makeSelectCorporealLawyers(),
  civilProceeding: makeSelectCivilProceeding(),
  sagisClaim: makeSelectSagisClaim(),
  dahirAmountsCorpo: makeSelectDahirAmountsCorpo(),
  linkToBeneficiaryCodes: makeSelectLinkToBeneficiaryCodes(),
  judgementOnMeritsMultiple: makeSelectJudgementOnMeritsMultiple(),
  appealOnMeritsMultiple: makeSelectAppealOnMeritsMultiple(),
  judgementOnMeritsByVictims: makeSelectJudgementOnMeritsByVictims(),
  judgementOnMeritsByVehicles: makeSelectJudgementOnMeritsByVehicles(),
  corporealEncryptedDocuments: makeSelectEncryptedDocuments(),
  materialEncryptedDocuments: makeSelectMaterialEncryptedDocuments(),
  expertExpertise: makeSelectVictimExpertise(),
  loaders: selectedLoader,
  assignedLawyers: makeSelectAssignedLawyers(),
  currentIndexTabManager: makeSelectCurrentTabManager(),
  currentGlobalTabManagerIndex: makeSelectGlobalCurrentTabManager(),
  currentJudiciaryProccessId: makeSelectCurrentTabJudiciaryProcessManager(),
  regulations: makeRegulations(),
  createdRegulations: makeCreatedRegulations(),
  managerNotifcationsInboxes: makeSelectNotificationsInboxes(),
  currentTabManagerExpertise: makeSelectCurrentTabIndexExpertise(),
  decisionJudgementIds: makeSelectDecisionJudgmentIds(),
  claimHistoryActions: makeSelectClaimHistoryActions(),
  userActions: makeSelectClaimHistoryActions(),
  claimHistorySagis: makeSelectClaimHistorySagis(),
  instructions: makeInstructions(),
  pendingTasksClaim: makeSelectPendingTasksClaim(),
  claimCivilParty: makeSelectClaimCivilParty(),
  currentRegulationPath: makeSelectCurrentRegulationPath(),
  imagineNotification: makeSelectNotification(),
  victimDecisionFlow: makeSelectDecisionFlowVictim(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CourtManagerLegalProceedingsPage));
